import React from 'react';
import ContentLoader from 'react-content-loader';
import { Color } from '../../enums/Color';
import { useMediaQuery } from 'react-responsive';
import { merge } from 'react-merge';

const loaderStyles = {
    mobile: {
        width: "90%",
        margin: "4vh 5% 8vh 5%",
        contentHeight: "55vh",
        buttonWidth: "100%",
        buttonHeight: "5.58vh"
    },
    desktop: {
        width: "40%",
        margin: "6vh auto 10vh auto",
        contentHeight: "50vh",
        buttonWidth: "18.125vw",
        buttonHeight: "7.8vh"
    }
};

export const RecruiterInvitationLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    let styles = loaderStyles.mobile;
    if (!isMobile) {
        let extendStyles = merge(loaderStyles.mobile, loaderStyles.desktop);
        styles = extendStyles;
    }

    return (
        <div style={styles}>
            <ContentLoader
                speed={1}
                width={"100%"}
                height={styles.contentHeight}
                backgroundColor={Color.LoaderBackground}
                foregroundColor={Color.LoaderForeground}
            >
                {/* Full Name input */}
                <rect x="0%" y="0%"  rx="8" ry="8" width="35%" height="4%"/>
                <rect x="0%" y="6%"  rx="8" ry="8" width="100%" height="11%"/>

                {/* Password input */}
                <rect x="0%" y="22%" rx="8" ry="8" width="25%" height="4%"/>
                <rect x="0%" y="28%" rx="8" ry="8" width="100%" height="11%"/>

                {/* Confirm Password input */}
                <rect x="0%" y="44%" rx="8" ry="8" width="35%" height="4%"/>
                <rect x="0%" y="50%" rx="8" ry="8" width="100%" height="11%"/>

                {/* Submit button */}
                <rect x="0%" y="72%" rx="8" ry="8" width={styles.buttonWidth} height={styles.buttonHeight}/>
            </ContentLoader>
        </div>
    );
};
